module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "sat-data-agriculture--discovery-cover.436ac6ef.jpg";